<script>
import Vue from 'vue'
import {WS_URL} from '../../utils/config'

export default {
  name: 'AliveActions',
  computed: {
    /**
     * Ogni 5 minuti
     * @returns {number}
     * @constructor
     */
    PING_TIME () {
      return 60 * 1000 * 5
    }
  },
  data () {
    return {
      action: null
    }
  },
  methods: {
    pingAlive () {
      this.action = setInterval(() => {
        Vue.axios.post(`${WS_URL}ping`, {question: 'ping'}, {withCredentials: true})
        console.log('alive ping!')
      }, this.PING_TIME)
    },
    pingStop () {
      if (this.action) {
        console.log('destroyed ping!')
        clearTimeout(this.PING_TIME)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/AliveActions.vue